export default __webpack_public_path__ + "static/roadmaps-d94123daa471cb966e4682b6a71f3f40.mp4";